import AppStoreLink from './AppStoreLink'
import GooglePlayLink from './GooglePlayLink'

export { AppStoreLink, GooglePlayLink }
